/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1ClusterState } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_CLUSTER_STATE_ENTITY_NAME = 'o5.aws.deployer.v1.Cluster';
export const o5AwsDeployerV1ClusterStateEntity = new schema.Entity<O5AwsDeployerV1ClusterState>(O5_AWS_DEPLOYER_V1_CLUSTER_STATE_ENTITY_NAME, {}, { idAttribute: 'clusterId' });

